import axios from "axios";
import { ACCESS_TOKEN_KEY, BASIC_TOKEN_KEY } from "../modules/Auth/AuthContext/AuthContext.consts";

export const authAxios = axios.create({
  baseURL: "https://hcp-locator-translations-app.azurewebsites.net/api",
});

authAxios.interceptors.request.use((req) => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  const basicToken = localStorage.getItem(BASIC_TOKEN_KEY);

  req!.headers!.authorization = `Bearer ${accessToken}`;
  req!.headers!.basicAuthorization = `basic ${basicToken}`

  return req;
});
